<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .upgrade-trial-card {
    border-radius: utils.in_rem(12px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: utils.in_rem(162px);
    height: utils.in_rem(180px);
    position: relative;
    overflow: hidden;
    background-color: #e0f2fa;
    background-image: url("/assets/img/signup/background.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .image-container {
      width: 90%;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: utils.in_rem(3px);
      margin-left: utils.in_rem(10px);
      .upgrade-image {
        width: 100%;
        max-width: utils.in_rem(140px);
        height: auto;
        border-radius: utils.in_rem(8px);
        object-fit: cover;
        margin-right: utils.in_rem(-22px);
        flex-shrink: 0;
      }
    }
    .upgrade-cta-container {
      display: flex;
      height: 50%;
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      gap: utils.in_rem(16px);
      padding: utils.in_rem(6px);

      .upgrade-title {
        @include colors.color(black_90);
        font-size: utils.in_rem(12px);
        font-weight: bold;
        margin: utils.in_rem(8px) 0;
        flex-shrink: 0;
      }
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import UpgradeModal from "../../../modals/UpgradeModal/UpgradeModal.svelte";
  import {
    showUpgradeModal,
    sidebarIsExpanded,
  } from "../stores/sidebar-store.js";
  import upgradeTrialImage from "./Images/UpgradeTrial.png";

  const onclick = () => {
    $showUpgradeModal = true;
  };

  let text = $derived(
    $userStore.plgTrialDaysRemaining === 0 ? "Keep access" : "Get full access"
  );
</script>

{#if $sidebarIsExpanded}
  <div class="upgrade-trial-card">
    <div class="image-container">
      <img
        src={upgradeTrialImage}
        alt="Notetaker and Inbox Agent"
        class="upgrade-image"
      />
    </div>
    <div class="upgrade-cta-container">
      <div class="upgrade-title">Notetaker & Inbox Agent</div>
      <Button
        {onclick}
        size="small"
        kind="upgrade"
        style="width: 100%; height: 32px; padding-left: 6px; padding-right: 6px;"
      >
        {text}
      </Button>
    </div>
  </div>
{/if}

{#if $showUpgradeModal}
  <UpgradeModal />
{/if}
